export const PRODUCT_CATEGORIES = [
  'Electronics',
  'Clothing',
  'Footwear',
  'Accessories',
  'Home & Garden',
  'Beauty',
  'Sports',
  'Toys',
  'Books',
  'Other'
] as const;

export type ProductCategory = typeof PRODUCT_CATEGORIES[number];

// Subcategories per main category
export const PRODUCT_SUBCATEGORIES: Record<ProductCategory, string[]> = {
  'Electronics': [
    'Smartphones & Tablets',
    'Laptops & Computers',
    'Audio & Headphones',
    'Cameras & Photography',
    'Smart Home Devices',
    'Wearables & Fitness Trackers',
  ],
  'Clothing': [
    'Mens',
    'Womens',
    'Kids',
    'Tops & T-Shirts',
    'Dresses & Skirts',
    'Pants & Jeans',
    'Jackets & Outerwear',
    'Loungewear & Sleepwear',
  ],
  'Footwear': [
    'Sneakers',
    'Sandals & Flip-Flops',
    'Boots',
    'Formal Shoes',
    'Slippers & Indoor Shoes',
    'Sports & Outdoor Shoes',
  ],
  'Accessories': [
    'Bags & Backpacks',
    'Jewelry & Watches',
    'Belts & Wallets',
    'Hats & Caps',
    'Scarves & Gloves',
    'Sunglasses',
  ],
  'Home & Garden': [
    'Furniture',
    'Kitchen & Dining',
    'Home Décor',
    'Bedding & Linens',
    'Outdoor Furniture & Gardening',
    'Lighting & Fixtures',
  ],
  'Beauty': [
    'Skincare',
    'Haircare',
    'Makeup & Cosmetics',
    'Fragrances',
    'Bath & Body',
    'Beauty Tools & Devices',
  ],
  'Sports': [
    'Fitness Equipment',
    'Team Sports Gear',
    'Outdoor & Camping',
    'Cycling & Biking',
    'Water Sports',
    'Winter Sports',
  ],
  'Toys': [
    'Action Figures & Collectibles',
    'Dolls & Plush Toys',
    'Puzzles & Board Games',
    'Educational Toys',
    'Outdoor Play Equipment',
    'Building Blocks & Construction Sets',
  ],
  'Books': [
    'Fiction',
    'Non-Fiction',
    'Children’s Books',
    'Textbooks & Educational',
    'Comics & Graphic Novels',
    'Cookbooks & Lifestyle',
  ],
  'Other': [],
};

export const getSubcategories = (category: ProductCategory | string | undefined) => {
  if (!category) return [] as string[];
  return PRODUCT_SUBCATEGORIES[category as ProductCategory] || [];
};

// Audiences (sub-sub-categories) for Footwear
export const FOOTWEAR_AUDIENCES = [
  'Mens',
  'Womens',
  'Unisex',
  'Children',
] as const;

export type FootwearAudience = typeof FOOTWEAR_AUDIENCES[number];

export const getAudiencesForCategory = (category: ProductCategory | string | undefined): string[] => {
  if (!category) return [];
  if ((category as string).toLowerCase() === 'footwear') return [...FOOTWEAR_AUDIENCES];
  return [];
};
